// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"UserPanelTablet_mainWrapper__1gjBW","whiteWrapper":"UserPanelTablet_whiteWrapper__2Bcn7","contentWrapper":"UserPanelTablet_contentWrapper__2FFW7"};